<div class="app-grid">
    <mat-form-field class="columns-12">
        <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.locationTypeTitleLabel' | appTranslate }}</mat-label>
        <mat-select
            required
            placeholder="{{ 'forms.applicant-tracker.selectAnOption' | appTranslate }}"
            name="jobPostingLocationTypeId"
            #jobPostingLocationTypeId="ngModel"
            [(ngModel)]="jobPosting.jobPostingLocationTypeId"
            (selectionChange)="onSelected($event)"
        >
            <mat-select-trigger *ngIf="selectedId && getLocationType()">
                {{ locationTypeMeta[getLocationType().name].label | appTranslate }}
            </mat-select-trigger>
            <mat-option class="flex mat-option" *ngFor="let locationType of locationTypes" [value]="locationType.id">
                <div class="font-semibold">{{ locationType.label | appTranslate }}</div>
                <div class="subscript">{{ locationTypeMeta[locationType.name].text | appTranslate }}</div>
            </mat-option>
        </mat-select>
        <mat-error *ngIf="jobPostingLocationTypeId.invalid">{{
            jobPostingLocationTypeId?.errors | formErrors
        }}</mat-error>
    </mat-form-field>
</div>
